import { useCallback, useEffect, useState } from "react";
import { Form } from "Components/Core";
import {
  HeaderComponent,
  TableComponent,
  SearchControl,
} from "Components/Shared";
import EditGeminiPromptModal from "Components/Shared/EditGeminiPromptModal";
import { getGeminiPromptsList } from "Api/Pages/GeminiPromptsApi";
import { GeminiPromptObjectType } from "Interfaces/Pages/GeminiPromptsInterface";
import { GEMINI_PROMPTS, CREATE_NEW_PROMPT, getColumns } from "./constants";
import { useAppSelector } from "App/hooks";
import { isAllowedTo } from "Utils/helper";

const GeminiPrompts = () => {
  const {
      userDetails: { permissions },
    } = useAppSelector((state) => state.loginReducer),
    [promptsList, setPromptsList] = useState<GeminiPromptObjectType[]>([]),
    [isModalVisible, setIsModalVisible] = useState<boolean>(false),
    [selectedPrompt, setSelectedPrompt] =
      useState<GeminiPromptObjectType | null>(null),
    [searchInput, setSearchInput] = useState<string>("");

  const fetchPromptsList = useCallback(async (searchQuery?: string) => {
    const { prompts } = await getGeminiPromptsList(searchQuery);
    setPromptsList(prompts);
  }, []);

  const onUpdatePrompt = (id: number) => {
    const prompt = promptsList.find((p) => p.id === id);
    if (prompt) {
      setSelectedPrompt(prompt);
      setIsModalVisible(true);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedPrompt(null);
  };

  const handleCreatePrompt = () => {
    setSelectedPrompt(null);
    setIsModalVisible(true);
  };

  const handleSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      setSearchInput(value);
    },
    []
  );

  const handleUpdateSuccess = () => {
    fetchPromptsList(searchInput.trim() || undefined);
  };

  useEffect(() => {
    fetchPromptsList(searchInput.trim() || undefined);
  }, [searchInput, fetchPromptsList]);

  return (
    <div className="ss-page-content d-flex flex-column flex-1 scroll-y bg-white">
      <HeaderComponent
        title={GEMINI_PROMPTS}
        shouldShowNav={false}
        buttonProps={
          isAllowedTo("GeminiPrompt", "create", permissions)
            ? {
                buttonText: CREATE_NEW_PROMPT,
                onClick: handleCreatePrompt,
              }
            : undefined
        }
      />
      <div className="ss-page-body d-flex flex-column flex-1 scroll-y py-4">
        <Form className="d-flex justify-content-end mb-4 px-4">
          <SearchControl
            placeholder="Search"
            label="Search"
            onChange={handleSearch}
          />
        </Form>
        <div className="table-responsive px-4">
          <TableComponent
            columns={getColumns({
              onUpdate: onUpdatePrompt,
              permissions,
            })}
            tableData={promptsList}
            isClickAble={false}
          />
        </div>
      </div>
      <EditGeminiPromptModal
        isModalVisible={isModalVisible}
        prompt={selectedPrompt}
        existingPrompts={promptsList}
        toggleModal={handleModalClose}
        onUpdateSuccess={handleUpdateSuccess}
      />
    </div>
  );
};

export default GeminiPrompts;
